// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__12vZs","grid":"styles_grid__I-k3r"};